module.exports = __webpack_public_path__ + "static/media/foods.d6f8df3a.jpg";